/**
 * @generated SignedSource<<ce32fb58bab19b0ee167930d6d2ce36e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReactionCue = "CELEBRATE" | "CURIOUS" | "DELIGHTED" | "ENCOURAGING" | "IMPRESSED" | "%future added value";
export type TurnState = "IDLE" | "NEEDS_REPEAT" | "SPEAKING" | "THINKING" | "TRANSCRIBING" | "%future added value";
export type SessionViewEventsSubscription$variables = {
  sessionId: string;
};
export type SessionViewEventsSubscription$data = {
  readonly sessionEvents: {
    readonly __typename: "LearnerTurnCommitted";
    readonly transcript: string;
    readonly translationTarget: string | null | undefined;
    readonly turnId: string;
  } | {
    readonly __typename: "PartialTranscript";
    readonly text: string;
  } | {
    readonly __typename: "SessionEnded";
    readonly sessionId: string;
  } | {
    readonly __typename: "SessionFailed";
    readonly reason: string;
  } | {
    readonly __typename: "StateChanged";
    readonly state: TurnState;
  } | {
    readonly __typename: "TurnErrors";
    readonly errors: ReadonlyArray<{
      readonly end: number;
      readonly id: string;
      readonly learnerForm: string;
      readonly start: number;
      readonly targetForm: string;
    }>;
    readonly turnId: string;
  } | {
    readonly __typename: "TurnReaction";
    readonly cue: ReactionCue;
    readonly turnId: string;
  } | {
    readonly __typename: "TutorTextDelta";
    readonly text: string;
  } | {
    readonly __typename: "TutorTurnCommitted";
    readonly transcript: string;
    readonly translationTarget: string | null | undefined;
    readonly turnId: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type SessionViewEventsSubscription = {
  response: SessionViewEventsSubscription$data;
  variables: SessionViewEventsSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "turnId",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "transcript",
    "storageKey": null
  },
  (v2/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "translationTarget",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "sessionEvents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          }
        ],
        "type": "StateChanged",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v1/*:: as any*/),
        "type": "PartialTranscript",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v3/*:: as any*/),
        "type": "LearnerTurnCommitted",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v1/*:: as any*/),
        "type": "TutorTextDelta",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v3/*:: as any*/),
        "type": "TutorTurnCommitted",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cue",
            "storageKey": null
          },
          (v2/*:: as any*/)
        ],
        "type": "TurnReaction",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MarkedError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "start",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "end",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "learnerForm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "targetForm",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "TurnErrors",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reason",
            "storageKey": null
          }
        ],
        "type": "SessionFailed",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionId",
            "storageKey": null
          }
        ],
        "type": "SessionEnded",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionViewEventsSubscription",
    "selections": (v4/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "SessionViewEventsSubscription",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "cacheID": "5e3787295102bb19fc69e2a9647f03cf",
    "id": null,
    "metadata": {},
    "name": "SessionViewEventsSubscription",
    "operationKind": "subscription",
    "text": "subscription SessionViewEventsSubscription(\n  $sessionId: ID!\n) {\n  sessionEvents(sessionId: $sessionId) {\n    __typename\n    ... on StateChanged {\n      state\n    }\n    ... on PartialTranscript {\n      text\n    }\n    ... on LearnerTurnCommitted {\n      transcript\n      turnId\n      translationTarget\n    }\n    ... on TutorTextDelta {\n      text\n    }\n    ... on TutorTurnCommitted {\n      transcript\n      turnId\n      translationTarget\n    }\n    ... on TurnReaction {\n      cue\n      turnId\n    }\n    ... on TurnErrors {\n      turnId\n      errors {\n        id\n        start\n        end\n        learnerForm\n        targetForm\n      }\n    }\n    ... on SessionFailed {\n      reason\n    }\n    ... on SessionEnded {\n      sessionId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a27ccad51f224e850e086c65a28ef9e";

export default node;
